<template>
	<div class="top-divider">
		<v-text-field
			class="mt-4 no-line"
			label="社員情報"
			outlined
			dense
			v-if="customer_person.name"
			v-model="customer_person.name"
			readonly
			persistent-hint
			hint="右のアイコンから編集・削除が可能です"
			><template v-slot:append-outer>
				<v-btn icon class="ml-2" @click="dialog = true"><v-icon>mdi-pencil</v-icon></v-btn>
				<v-btn icon class="ml-2" @click="deleteCustomerPerson"><v-icon>mdi-delete</v-icon></v-btn>
			</template></v-text-field
		>
		<v-dialog
			v-model="dialog"
			max-width="700px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
			@click:outside="closeDialog"
		>
			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary" tag="div">
					<v-app-bar-title class="color-white">社員情報登録</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="closeDialog" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>

				<v-form class="pa-2" ref="form" v-model="valid">
					<v-text-field label="社員名(必須)" v-model="customerPerson.name" :rules="[rules.required]" dense outlined class="mt-4" />
					<v-text-field label="社員名（カナ）" v-model="customerPerson.name_kana" dense outlined class="mt-4" />
					<div class="mt-4">
						<label class="text-body-2 font-weight-bold">生年月日</label>
						<v-row class="mt-4" no-gutters>
							<v-col class="pr-1" sm="4">
								<v-combobox v-model="year" dense outlined :items="years" @change="changeBirthDay">
									<template v-slot:append-outer>年</template>
								</v-combobox>
							</v-col>
							<v-col class="px-1" sm="4">
								<v-combobox v-model="month" dense outlined :items="months" @change="changeBirthDay">
									<template v-slot:append-outer>月</template>
								</v-combobox>
							</v-col>
							<v-col class="pl-1" sm="4">
								<v-combobox v-model="day" dense outlined :items="days" @change="changeBirthDay">
									<template v-slot:append-outer>日</template>
								</v-combobox>
							</v-col>
						</v-row>
					</div>
					<div class="mt-4">
						<label class="text-body-2 font-weight-bold">性別</label>
						<v-radio-group v-model="customerPerson.gender" row>
							<v-radio label="未設定" value="unspecified" class="mr-2 mt-1" dense />
							<v-radio label="男性" value="male" class="mr-2 mt-1" dense />
							<v-radio label="女性" value="female" class="mr-2 mt-1" dense />
						</v-radio-group>
					</div>

					<v-text-field label="電話番号" v-model="customerPerson.phone" dense outlined class="mt-4" />
					<v-text-field label="FAX番号" v-model="customerPerson.fax" dense outlined class="mt-4" />
					<v-text-field label="役職" v-model="customerPerson.position" dense outlined class="mt-4" />
					<v-text-field label="部門" v-model="customerPerson.department" dense outlined class="mt-4" />
				</v-form>
				<p class="pa-2 text-body-2 red--text">登録ボタンを押すまで変更は反映されません。</p>
				<v-card-actions>
					<v-row no-gutters class="pb-2">
						<v-col sm="4" cols="0" />
						<v-col sm="4" cols="12">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="saveForm" :disabled="!valid">
									<v-icon class="mr-2">mdi-plus</v-icon>
									登録する
								</v-btn>
							</v-row>
						</v-col>
						<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rules from "../../../helper/rules"
import _ from "lodash"

export default {
	props: {
		customer_person: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	data() {
		return {
			dialog: this.customer_person.id ? false : true,
			valid: false,
			rules: rules,
			customerPerson: {
				name: null,
				name_kana: null,
				birth_day: null,
				gender: null,
				position: null,
				phone: null,
				fax: null,
				email: null,
				department: null,
			},
			year: null,
			month: null,
			day: null,
		}
	},
	mounted() {
		this.customerPerson = _.cloneDeep(this.customer_person)
	},
	methods: {
		saveForm() {
			this.dialog = false
			this.$emit("change-customer-person", _.cloneDeep(this.customerPerson))
		},
		deleteCustomerPerson() {
			this.$emit("delete-customer-person")
		},
		changeBirthDay() {
			if (this.year && this.month && this.day) return (this.customerPerson.birth_day = null)
			this.customerPerson.birth_day = `${this.year}-${this.month}-${this.day}`
		},
		closeDialog() {
			this.dialog = false
			if (!this.customer_person.name) {
				this.$emit("delete-customer-person")
			}
		},
	},
	computed: {
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		// customerPerson: {
		// 	get() {
		// 		return this.customer_person
		// 	},
		// 	set(newVal) {
		//     console.log(newVal)
		//     console.log(this.customer_person)
		// 		// return this.$emit("update:customer_person", newVal)
		// 	},
		// },
	},
	watch: {
		// customer_person: {
		// 	handler(newVal, _) {
		// 		this.customerPerson = newVal
		// 	},
		// },
		// immediate: true,
		// deep: true,
	},
}
</script>